/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { IdpService } from '../auth/services/auth.service';
import { Router } from '@angular/router';
import { EmployeeService } from 'src/app/home/services/employee.service';
import { TermsService } from '../home/services/terms.service';

export interface TerminosElement {
  title: string;
  contenido: string;
}

@Component({
  selector: 'app-terminos-condiciones',
  templateUrl: './terminos-condiciones.component.html',
  styleUrls: ['./terminos-condiciones.component.scss'],
})
export class TerminosCondicionesComponent  {
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;
  isBeneficiariesFormRoute = false;
  element = false;
  element2 = false;
  logeoclass = 'oculta';
  isDisabled = true;
  clase = 'button-disable';
  isDisabled2 = true;
  clase2 = 'button-disable';
  checkbox = false;
  checkbox2 = false;

  constructor(
    private _idpService: IdpService,
    private router: Router,
    private EmployeeByEmailService: EmployeeService,
    private terms_service: TermsService
  ) {}

  

  cerrarSesion() {
    this._idpService.logout();
  }

  goToAdmin() {
    this.router.navigate(['/admin']);
    localStorage.setItem('admin', 'true');
    this._idpService.admin.next(true);
  }

  goToHome() {
    this.logeoclass = 'visible';
    this.router.navigate(['/home']);
  }

  getActualRoute(actualRoute: string) {
    this.isBeneficiariesFormRoute = actualRoute === '/beneficiaries-form';
  }

  showData() {
    this.element = true;
    this.element2 = false;
  }

  hideData() {
    if (!this.isDisabled) {
      this.checkbox = true;
    }

    if (!this.isDisabled2) {
      this.checkbox2 = true;
    } else {
      this.checkbox2 = false;
    }

    this.element = false;
    this.element2 = true;
  }

  switchClicked(event: any) {
    if (event.srcElement.checked) {
      this.isDisabled = false;
      this.clase = 'button-add-profile';
    } else {
      this.isDisabled = true;
      this.clase = 'button-disable';
    }
  }

  switchClicked2(event: any) {
    if (event.srcElement.checked) {
      this.isDisabled2 = false;
      this.clase2 = 'button-add-profile';
    } else {
      this.isDisabled2 = true;
      this.clase2 = 'button-disable';
    }
  }

  async editStatusTerminos(objectEdit: any) {
    try {
      await this.EmployeeByEmailService.putEmployee(objectEdit);
      this.logeoclass = 'visible';
      this.router.navigate(['/home']);
    } catch (error) {
      console.error('Error al editar el archivo JSON:', error);
    }
  }

  async statusChange() {
    await this.terms_service.setTermsConditionUser();
    
    // Verificar si hay una URL de retorno guardada
    const returnUrl = sessionStorage.getItem('returnUrl');
    if (returnUrl) {
      sessionStorage.removeItem('returnUrl');
      this.router.navigateByUrl(returnUrl);
    } else {
      this.router.navigate(['/welcome']);
    }
  }

  actualityDate() {
    const fecha = new Date();
    const dia = ('0' + fecha.getDate()).slice(-2);
    const mes = this.month(fecha.getMonth());
    const anio = fecha.getFullYear();
    const fechaFormateada = `${dia} de ${mes} del ${anio}`;
    return fechaFormateada;
  }

  month(mes: number) {
    const arrMeses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    let mesSelecionado = '';
    for (let i = 0; i <= arrMeses.length; i++) {
      if (i === mes) {
        mesSelecionado = arrMeses[i];
      }
    }
    return mesSelecionado;
  }
}
